import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

import { AllEnterpriseModule, ColumnApiModule, GridStateModule, LicenseManager, MasterDetailModule, RowApiModule, RowStyleModule } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-075217}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Lemonkode_(pty)_LTD}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{TobTrack}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{TobTrack}_need_to_be_licensed___{TobTrack}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{17_January_2026}____[v3]_[01]_MTc2ODYwODAwMDAwMA==67060da52d618e6753de5df93b4e6363");

import { ModuleRegistry, QuickFilterModule, ValidationModule } from 'ag-grid-community';
import { ClientSideRowModelModule } from 'ag-grid-community';
import {
    CellSelectionModule,
    ClipboardModule,
    ColumnMenuModule,
    ContextMenuModule,
    ExcelExportModule,
    RowGroupingPanelModule,
    RowGroupingModule,
    PinnedRowModule
} from "ag-grid-enterprise";

ModuleRegistry.registerModules([
    AllEnterpriseModule,
    ClientSideRowModelModule,
    ClipboardModule,
    ExcelExportModule,
    ColumnMenuModule,
    ContextMenuModule,
    CellSelectionModule,
    QuickFilterModule,
    RowGroupingPanelModule,
    RowGroupingModule,
    PinnedRowModule,
    RowStyleModule,
    RowApiModule,
    ColumnApiModule,
    MasterDetailModule,
    GridStateModule,
    ValidationModule /* Development Only */,
]);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);